import styled from "styled-components";
import {RED} from '../../../css-constants';

interface LiveCasinoGridItemDrawDefaultBoxProps {
  drawColor: string;
}

export const LiveCasinoGridItemDrawDefaultBox = styled.div<LiveCasinoGridItemDrawDefaultBoxProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.8em;
  height: 1.8em;
  font-size: 1.2em;
  font-weight: 900;
  border-radius: 2px;

  color: ${({theme, drawColor}) => {

    if (drawColor) {
      return drawColor === RED
        ? theme.components.newLiveCasino.colors.gridItem.drawRedItemBackground
        : theme.components.newLiveCasino.colors.gridItem.drawGreenItemFirstChildBackground;
    }

    return theme.colors.buttonLight;
  }};

  &:first-child {

    color: ${({theme, drawColor}) => {
      return drawColor ? theme.colors.buttonLight : theme.colors.buttonDark;
    }};

    background: ${({theme, drawColor}) => {

      if (drawColor) {
        return drawColor === RED
          ? theme.components.newLiveCasino.colors.gridItem.drawRedItemFirstChildBackground
          : theme.components.newLiveCasino.colors.gridItem.drawGreenItemFirstChildBackground;
      }

      return theme.colors.buttonLight;
    }};
  }
`;